import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Mail, MessageCircle, Search } from 'lucide-react';

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="sbb-footer">
      <div className="footer-main-area">
        <div className="container">
        <div className="footer-grid">
          <div className="footer-col brand-col">
            <div className="footer-brand-title">SOLUSI BANGUN BETON</div>
            <div className="footer-badge-sig">Member of SIG</div>
            <p className="footer-tagline">{t('footer_tagline')}</p>
            <div className="footer-copyright-copy">
              <p>Copyright © {currentYear}</p>
              <p>PT Solusi Bangun Beton</p>
              <p>All rights reserved.</p>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Alamat & Kontak</h4>
            <ul className="footer-contact-list">
              <li>
                <MapPin size={18} className="icon-red" />
                <span>{t('footer_address')}</span>
              </li>
              <li>
                <Phone size={16} className="icon-red" />
                <span>(021) 2986-1000</span>
              </li>
              <li>
                <Mail size={16} className="icon-red" />
                <span>info@solusibangunbeton.com</span>
              </li>
              <li>
                <MessageCircle size={16} className="icon-red" />
                <span>+62 811-1000-8888 (WhatsApp)</span>
              </li>
            </ul>
          </div>

          <div className="footer-col footer-discover">
            <h4 className="footer-col-title">Jelajahi</h4>
            <Link to="/pencarian" className="footer-search-link">
              <span>Pencarian situs</span>
              <Search size={18} />
            </Link>
            <div className="footer-inline-links">
              <Link to="/produk-layanan">{t('nav_products')}</Link>
              <Link to="/tentang-kami">{t('nav_about')}</Link>
              <Link to="/pelanggan-proyek">{t('nav_projects')}</Link>
              <Link to="/blog">{t('nav_news')}</Link>
            </div>
            <div className="social-links-wrapper">
              <span className="social-label">Media Sosial</span>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-badge">Instagram</a>
              <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="social-badge">TikTok</a>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div className="footer-bottom-area">
        <div className="container footer-bottom-bar">
          <Link to="/kebijakan-privasi">{t('footer_privacy')}</Link>
          <span className="footer-member-mark">Member of <strong>SIG</strong></span>
        </div>
      </div>

      <style>{`
        .sbb-footer {
          color: #e0e0e0;
          margin-top: 0;
        }

        .footer-main-area {
          background-color: rgba(0, 0, 0, 0.88);
          padding: 60px 0 40px;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 60px;
        }

        .footer-brand-title {
          font-size: 24px;
          font-weight: 800;
          color: #ffffff;
          letter-spacing: -0.5px;
        }

        .footer-badge-sig {
          display: inline-block;
          font-size: 11px;
          font-weight: 700;
          background-color: var(--color-brand-accent-green);
          color: #1a1a1a;
          padding: 3px 8px;
          border-radius: 0;
          margin: 8px 0 16px 0;
          text-transform: uppercase;
        }

        .footer-tagline {
          font-size: 14px;
          color: #a0a0a0;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .footer-copyright-copy {
          font-size: 13px;
          color: #a8a8a8;
          line-height: 1.65;
        }

        .footer-col-title {
          font-size: 14px;
          font-weight: 600;
          color: #ffffff;
          text-transform: uppercase;
          letter-spacing: .4px;
          margin-bottom: 20px;
          position: relative;
          padding-bottom: 8px;
        }

        .footer-col-title::after {
          display: none;
        }

        .footer-inline-links {
          display: flex;
          flex-wrap: wrap;
          gap: 10px 18px;
          margin-top: 22px;
        }

        .footer-inline-links a {
          font-size: 14px;
          color: #b0b0b0;
          transition: color 0.2s ease;
        }

        .footer-inline-links a:hover {
          color: #ffffff;
        }

        .footer-contact-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 14px;
          font-size: 14px;
          color: #b0b0b0;
        }

        .footer-contact-list li {
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }

        .icon-red {
          color: var(--color-brand-accent-green);
          flex-shrink: 0;
          margin-top: 3px;
        }

        .social-links-wrapper {
          margin-top: 24px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .social-label {
          font-size: 13px;
          color: #808080;
        }

        .social-badge {
          font-size: 12px;
          font-weight: 600;
          background-color: #2a2a2a;
          color: #ffffff;
          padding: 4px 10px;
          border-radius: 0;
          transition: background-color 0.2s ease;
        }

        .social-badge:hover {
          background-color: var(--color-brand-primary);
        }

        .footer-search-link {
          min-height: 48px;
          padding: 0 16px;
          background: #ffffff;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
        }

        .footer-bottom-area {
          background: #ffffff;
          color: #333333;
          border-top: 1px solid rgba(0,0,0,0.1);
        }

        .footer-bottom-bar {
          min-height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 13px;
          color: #333333;
        }

        .footer-member-mark {
          font-size: 13px;
          color: #555;
        }

        .footer-member-mark strong {
          font-size: 22px;
          margin-left: 4px;
          color: var(--color-ink);
        }

        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr;
          }
          .footer-bottom-bar {
            flex-direction: column;
            gap: 12px;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
